@if (mostrandoTelaCadastro && !modoSomenteLeitura()) {
    <app-consultorio-create-dialog [pessoa]="pessoa()" (cancelarCadastro)="fecharTelaCadastro()" (consultorioCreated)="onConsultorioCreated()"></app-consultorio-create-dialog>
} @else if (!selectedDetail) {
    <app-consultorio-lista [pessoa]="$any(pessoa())" [bloquearNovo]="!medicoRegular()" (rowClick)="onRowClick($event)" (novoClick)="abrirNovoDialog()"></app-consultorio-lista>
} @else {
    <app-card-content [border]="false" [headerColor]="true" icon="pi pi-building" title="Consultório Privado">
        <div card-header class="flex items-center gap-2">
            <p-button icon="pi pi-arrow-left" [text]="true" [rounded]="true" size="small" (onClick)="voltarParaLista()" pTooltip="Voltar" tooltipPosition="left" />
            @if (!modoSomenteLeitura()) {
                <app-botao-acoes [label]="'Ações'" [items]="acoesNovo" [appCan]="roleConsultorioEditar" [appCanUf]="pessoa()?.uf" />
            }
        </div>

        <!-- `mostrarEntradaDeEdicao=false`: "Editar" vive no menu de Ações do cabeçalho; aqui ficam só Salvar/Cancelar. -->
        <app-tab-container
            [options]="options"
            [selected]="selectedValue"
            (selectedChange)="tabChange($event)"
            [useEditButton]="isEditTab && !modoSomenteLeitura()"
            [useEditActionsMenu]="true"
            [mostrarEntradaDeEdicao]="false"
            [modoEdicao]="edicaoAberta"
            (modoEdicaoChange)="aoMudarModoEdicao($event)"
            [useHeader]="false"
            (salvar)="saveDadosGerais = true"
            (cancelar)="cancelDadosGerais = true"
            (edicaoEnabled)="enableDadosGerais = true"
        >
            <app-tab-content [value]="'dados-gerais'">
                <ng-template [ngTemplateOutlet]="dadosGerais"></ng-template>
            </app-tab-content>
            <app-tab-content [value]="'compartilhamento'">
                <ng-template [ngTemplateOutlet]="compartilhamento"></ng-template>
            </app-tab-content>
            <app-tab-content [value]="'anotacoes'">
                <ng-template [ngTemplateOutlet]="anotacoes"></ng-template>
            </app-tab-content>
            <app-tab-content [value]="'especialidade'">
                <ng-template [ngTemplateOutlet]="especialidade"></ng-template>
            </app-tab-content>
            <app-tab-content [value]="'historico'">
                <ng-template [ngTemplateOutlet]="historico"></ng-template>
            </app-tab-content>
            <app-tab-content [value]="'horario-funcionamento'">
                <ng-template [ngTemplateOutlet]="horarioFuncionamento"></ng-template>
            </app-tab-content>
            <app-tab-content [value]="'telefone'">
                <ng-template [ngTemplateOutlet]="telefone"></ng-template>
            </app-tab-content>
        </app-tab-container>
    </app-card-content>
}

<ng-template #dadosGerais>
    @if (selectedValue === 'dados-gerais') {
        <app-consultorio-dados-gerias
            (emitActions)="setTabActions('dados-gerais', $event)"
            [pessoa]="pessoa()"
            [idConsultorio]="selectedConsultorioId"
            [(save)]="saveDadosGerais"
            [(cancel)]="cancelDadosGerais"
            [(enable)]="enableDadosGerais"
        ></app-consultorio-dados-gerias>
    }
</ng-template>
<ng-template #compartilhamento>
    @if (selectedValue === 'compartilhamento') {
        <app-consultorio-compartilhamento (emitActions)="setTabActions('compartilhamento', $event)" [pessoa]="pessoa()" [idConsultorio]="selectedConsultorioId"></app-consultorio-compartilhamento>
    }
</ng-template>

<ng-template #especialidade>
    @if (selectedValue === 'especialidade') {
        <app-consultorio-especialidade (emitActions)="setTabActions('especialidade', $event)" [pessoa]="pessoa()" [idConsultorio]="selectedConsultorioId"></app-consultorio-especialidade>
    }
</ng-template>
<ng-template #anotacoes>
    @if (selectedValue === 'anotacoes') {
        <app-consultorio-anotacoes (emitActions)="setTabActions('anotacoes', $event)" [pessoa]="pessoa()" [idConsultorio]="selectedConsultorioId"></app-consultorio-anotacoes>
    }
</ng-template>
<ng-template #historico>
    @if (selectedValue === 'historico') {
        <app-consultorio-historico (emitActions)="setTabActions('historico', $event)" [pessoa]="pessoa()" [idConsultorio]="selectedConsultorioId"></app-consultorio-historico>
    }
</ng-template>
<ng-template #horarioFuncionamento>
    @if (selectedValue === 'horario-funcionamento') {
        <app-consultorio-horario (emitActions)="setTabActions('horario-funcionamento', $event)" [pessoa]="pessoa()" [idConsultorio]="selectedConsultorioId"></app-consultorio-horario>
    }
</ng-template>
<ng-template #telefone>
    @if (selectedValue === 'telefone') {
        <app-consultorio-telefone (emitActions)="setTabActions('telefone', $event)" [pessoa]="pessoa()" [idConsultorio]="selectedConsultorioId"></app-consultorio-telefone>
    }
</ng-template>
